module.exports = __webpack_public_path__ + "img/search_white.325a40da.svg";